// extracted by mini-css-extract-plugin
export default {"loaderSection":"loader_loaderSection__C7K3O","loaderSecitionh1":"loader_loaderSecitionh1__y6QvZ","lds_ring":"loader_lds_ring__j5WiQ"};